import React, { useEffect, useState } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Stack,
    IconButton,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    Card,
    MenuItem,
    ListItemText,
    FormHelperText,
    styled,
    FormGroup,
    Checkbox,
    Button
} from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { useNavigate } from "react-router-dom"
import { useFormik } from 'formik';

import CommonBreadcumbs from '../common/CommonBreadcumbs';
import CommonSectionHeader from "../common/CommonSectionHeader";
import CommonRestricted from '../common/CommonRestricted';

import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import {
    useInjectionProps,
    propTypes as injectionPropTypes,
    propFieldTypes as injectionPropFieldTypes,
    propRefs as injectionPropRefs
} from "../../hooks/api/useInjectionProps";
import { useSystemPrompt } from "../../hooks/useSystemPrompt";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';
import { useTranslations } from "../../hooks/useTranslations";

// import { mergeSchema } from "../../utils/dataSchema";

import {
    initialValues,
    validationSchema,
} from "../../schema/injectionProps/injectionPropSchema";

import { CommonIcons, icons } from "../common/CommonIcons";

import { capitalizeString } from "../../utils/formatString"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export default function NewInjectionProp({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@injectionProp", "prompt"] })

    const { promptMessage } = useSystemPrompt();
    const { isLoading, create } = useInjectionProps({ propType: "", targetType: "" });
    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.customField.id, scopeTypes.customField.customField.id)

    const [inputType, setInputType] = useState("")

    // const [selection, setSelection] = useState(getCustomFieldsDefinitions())

    const onSubmit = async (currentValues) => {

        console.log('currentValues', currentValues)

        try {

            // get target type
            // getting the ref id
            let refIdField = ''
            let _targetType = ''

            Object.keys(injectionPropTypes).forEach(i => {
                Object.keys(injectionPropTypes[i]).forEach(i2 => {
                    if (injectionPropTypes[i][i2].id === currentValues?.propsModule) {
                        refIdField = i2
                        _targetType = injectionPropTypes[i][i2].target
                    }
                })
            })

            let data = {
                injection_props: [{
                    props_module: currentValues?.propsModule,
                    props_ref: currentValues?.propsRef,
                    ref_id: {
                        [
                            injectionPropRefs[currentValues?.propsRef][refIdField]
                        ]: currentValues?.propsFieldValue
                    },
                    props_key: currentValues?.propsKey,
                    props_field: currentValues?.propsField,
                    [
                        injectionPropFieldTypes[currentValues?.propsField].fieldName
                    ]: currentValues?.propsValue,
                    is_multiple: currentValues?.isMultiple
                }]
            }

            console.log('data', data)

            const response = await create({ data, targetType: _targetType });

            promptMessage(true, `${response?.message}`)
            navigate(getRoute("settings/injectionProps"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const RenderForm = () => {

        // get the list options for props module
        let propsModuleLists = []

        if (values?.propsRef) {
            Object.keys(injectionPropTypes[values.propsRef]).forEach(i => {
                propsModuleLists.push({
                    ...injectionPropTypes[values.propsRef][i],
                    name: i
                })
            })
        }

        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>
                        <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t('properties')}
                                subTitle={t('detailOfTheInjectionProps')}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>
                            <Grid item xs={12} md={12} textAlign="left">
                                <Grid container spacing={1}>

                                    <Grid item xs={12} sm={12} md={6}>
                                        {/* <FormGroup> */}
                                        <FormControlLabel disabled checked control={<Checkbox />} label={t('singleValue')} />
                                        {/* </FormGroup> */}
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}><></></Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.propsRef)}
                                        >
                                            <InputLabel id="propsRef">{t('moduleReference')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("moduleReference")}
                                                name={`propsRef`}
                                                // handleChange={handleChange}
                                                onChange={(e) => {
                                                    setFieldValue(`propsRef`, e.target.value)
                                                    setFieldValue(`propsModule`, '')
                                                }}
                                                value={values?.propsRef}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    Object.keys(injectionPropTypes).map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={i}
                                                            >
                                                                {i}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.propsRef}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.propsModule)}
                                        >
                                            <InputLabel id="module">{t('moduleType')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("moduleType")}
                                                name={`propsModule`}
                                                onChange={(e) => {
                                                    setFieldValue(`propsModule`, e.target.value)
                                                }}
                                                value={values?.propsModule}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    propsModuleLists.map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={i?.id}
                                                            >
                                                                {i?.id}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.propsModule}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(errors?.propsField)}
                                        >
                                            <InputLabel id="module">{t('fieldType')}</InputLabel>
                                            <Select
                                                size="small"
                                                label={t("fieldType")}
                                                name={`propsField`}
                                                onChange={(e) => {
                                                    setFieldValue(`propsField`, e.target.value)
                                                }}
                                                value={values?.propsField}
                                            // renderValue={(e) => capitalizeString({ val: e })}
                                            >
                                                {
                                                    Object.keys(injectionPropFieldTypes).map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={injectionPropFieldTypes[i]?.id}
                                                            >
                                                                {injectionPropFieldTypes[i]?.id}
                                                                {/* <ListItemText primary={`${capitalizeString({ val: i.display })}`} /> */}
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {errors?.propsField}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>


                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            autoFocus
                                            fullWidth
                                            name={`propsFieldValue`}
                                            label={t("refFieldValue")}
                                            type="text"
                                            variant="outlined"
                                            value={values?.propsFieldValue}
                                            onChange={handleChange}
                                            error={Boolean(errors?.propsFieldValue)}
                                            helperText={(errors?.propsFieldValue)}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            autoFocus
                                            fullWidth
                                            name={`propsKey`}
                                            label={t("propKey")}
                                            type="text"
                                            variant="outlined"
                                            value={values?.propsKey}
                                            onChange={handleChange}
                                            error={Boolean(errors?.propsKey)}
                                            helperText={(errors?.propsKey)}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            autoFocus
                                            fullWidth
                                            name={`propsValue`}
                                            label={t("propValue")}
                                            type="text"
                                            variant="outlined"
                                            value={values?.propsValue}
                                            onChange={handleChange}
                                            error={Boolean(errors?.propsValue)}
                                            helperText={(errors?.propsValue)}
                                        />
                                    </Grid>


                                    {/* <Grid item xs={12} sm={12} md={6}>
                                        <FormControl
                                            margin="dense"
                                            fullWidth
                                            size="small"
                                            error={Boolean(touched.function) && Boolean(errors.function)}
                                        >
                                            <InputLabel id="function">Function Type</InputLabel>
                                            <Select
                                                size="small"
                                                labelId="function"
                                                label="function"
                                                name={"function"}
                                                onChange={handleChange}
                                                value={values.function}
                                            >
                                                {
                                                    getOptions({ moduleType: values.module }).map((i, index) => {
                                                        return (
                                                            <MenuItem
                                                                key={index}
                                                                value={i.id}
                                                            >
                                                                <ListItemText primary={`${capitalizeString({ val: i.display })}`} />
                                                            </MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                            <FormHelperText>
                                                {touched.function && errors.function}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid> */}

                                </Grid>
                            </Grid>

                        </Grid>

                    </Grid>
                </StyledCard>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>
                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newInjectionProp })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newInjectionProp")}
                breadcrumbs={[
                    {
                        displayText: t("injectionProps"),
                        props: {
                            href: getRoute("settings/injectionProps")
                        }
                    },
                    {
                        displayText: t("newInjectionProp"),
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}